var flyio = new Fly;
import store from '@@/assets/js/store';
const path = require('path');
const apis = require("../" + process.env.VUE_APP_NAME + "/assets/js/apis")

flyio.config.baseURL = process.env.NODE_ENV == "development" ? global.URL_DEV_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN

flyio.config.timeout = 0 //不超时
flyio.config.withCredentials = process.env.VUE_APP_IS_WITH_CREDENTIALS
flyio.config.headers = {
	"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
}

//添加请求拦截器
flyio.interceptors.request.use((config, promise) => {
	//给所有请求添加自定义header
	//config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
	//可以通过promise.reject／resolve直接中止请求
	//promise.resolve("fake data")
	// console.log((new Vue()).global_loading);
	// store.state.global_loading = true;

	store.commit('SET_GLOBAL_LOADING', true);


	return config;
})
//添加响应拦截器，响应拦截器会在then/catch处理之前执行
flyio.interceptors.response.use(
	(response, promise) => {
		store.commit('SET_GLOBAL_LOADING', false);

		(new Vue()).utils.saveCookie(() => {

		})

		//只将请求结果的data字段返回
		var result = JSON.parse(response.data);
		if (result.code == 200) {
			console.log(result)
			return result;
		} else if (result.code == 403) {
			//这里用event_hub，因为web和admin是不会有vux的bus的
			(new Vue()).utils.event_hub.$emit('403', null)

			return promise.reject(result.info)
		} else {
			console.log(result.info)
			return promise.reject(result.info)
		}
	},
	(err, promise) => {

		console.log(err.message)
		store.commit('SET_GLOBAL_LOADING', false);

		//发生网络错误后会走到这里
		return promise.reject(err.message);
	}
)
// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
	install: function (Vue, Option) {
		Object.defineProperty(Vue.prototype, "req", {
			value: flyio
		});
	}
};